import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout"
import AcceptableUsePolicy from "../../Components/AcceptableUsePolicy"

const B2CAcceptableUsePolicy = () => (
  <PublicLayout>
      <Box p={4}>
<AcceptableUsePolicy />
      </Box>
  </PublicLayout>
);

export default B2CAcceptableUsePolicy;